var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var LeftIcon = function (_a) {
    var color = _a.color;
    return (_jsx("svg", __assign({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1958 6.50247C11.6499 6.44086 12 6.05154 12 5.58047C12 5.06657 11.5834 4.64998 11.0695 4.64998L3.18315 4.64998L6.25685 1.58985L6.34716 1.48568C6.61822 1.12199 6.58929 0.604986 6.25965 0.273938C5.89704 -0.0902152 5.30789 -0.0914701 4.94374 0.271135L0.273903 4.92112L0.271331 4.92409C0.241004 4.95456 0.212774 4.98712 0.186877 5.02153L0.183345 5.02561C-0.0883293 5.39045 -0.0581436 5.9092 0.273903 6.23983L4.94374 10.8898L5.04829 10.9797C5.41314 11.2492 5.93001 11.2181 6.25965 10.887L6.34952 10.7825C6.61903 10.4176 6.58789 9.90074 6.25685 9.5711L3.18486 6.51096L11.0695 6.51096L11.1958 6.50247Z", fill: color }, void 0) }), void 0));
};
